export default {
    root: {
        padding: '8px'
    },
    inputMarginDense: {
        padding: '0px'
    },
    marginDense: {
        padding: '0px'
    },
    input: {
        marginBottom: '2px',
        padding: '0px',
    },
    error: {
        borderColor: 'red !important'
    }
}